// 企业接口
import http from "@/promise/http"
const CONTROLLER_NAME = "/enterprise/"
// 查询列表
export const postListPage = (pageNum, numPerPage, params) => {
  return http.post(CONTROLLER_NAME.concat("listPage"), {
    pageNum: pageNum,
    numPerPage: numPerPage,
    condition: params
  });
};

// 查询所有列表
export const getListAll = () => {
  return http.get(CONTROLLER_NAME.concat('listEnterpriseAll'))
}

// 查询单位详情
export const postDetail = id => {
  return http.post(CONTROLLER_NAME.concat("detail"), id);
};

// 新增或更新信息
export const postSubmitForm = infoForm => {
  return http.post(CONTROLLER_NAME.concat('saveOrUpdate'), infoForm)
}

// 删除单位
export const postRemove = ids => {
  return http.post(CONTROLLER_NAME.concat("remove"), ids);
};

// 进出场
export function postEntryOrExit(status, ids) {
  return http.post(CONTROLLER_NAME.concat("entryOrExit"), {
    status,
    ids
  });
}
